import React, { useEffect, useContext, Fragment } from 'react';
import proptypes from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Carousel } from '@thd-olt-component-react/carousel';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { GeneralCardMobile } from './GeneralCardMobile';
import { getCardType, FULL_CARD } from '../Helpers';
import Model from '../model/Model';
import { dataModel } from '../dataModel';
import './category-cards-mobile.scss';
import { useCategoryCard } from '../../hooks/useCategoryCard';

const { string, shape, bool, number } = proptypes;

const CategoryCardsMobile = ({
  keyword = null,
  navParam = null,
  storeId = null,
  data: propData = undefined,
  loading: propLoading = undefined,
  error: propError = undefined,
  ssr = false,
  componentPosition = 1
}) => {

  const { store, clientStore } = useContext(ExperienceContext);
  const { data, loading, error } = useCategoryCard({
    clientStore,
    store,
    storeId,
    keyword,
    navParam,
    propLoading,
    propData,
    propError,
    ssr
  });

  useEffect(() => {
    const lifeCycleEventBus = window.LIFE_CYCLE_EVENT_BUS;
    if (lifeCycleEventBus?.lifeCycle?.trigger) {
      lifeCycleEventBus.lifeCycle.trigger('category-cards.ready');
    }
  }, []);
  const categoryCardsContainerImpression = {
    id: '',
    component: 'CategoryCards',
    name: 'CategoryCards',
    type: 'content'
  };
  if (!keyword && !navParam && typeof propLoading === 'undefined') {
    return null;
  }

  const renderFull = (categoryCards) => {
    const { majorDetails, majorHeader } = categoryCards;

    if (!majorHeader || !majorDetails) return null;

    return (
      <ImpressionProvider
        data={categoryCardsContainerImpression}
      >
        <div
          className="category-cards"
          data-component="CategoryCardsMobile"
          id={`${data.id}-${data.component}-${componentPosition}`}
          data-component-position={componentPosition}
        >
          <Col className="category-cards__zone-wrapper category-cards__full-card">
            <GeneralCardMobile
              type={FULL_CARD}
              header={majorHeader}
              details={majorDetails}
              componentPosition={componentPosition}
              category={majorHeader?.description}
            />
          </Col>
        </div>
      </ImpressionProvider>
    );
  };

  const getCarouselCards = (carouselCards = []) => {
    return carouselCards?.filter((carouselCard) => carouselCard)?.map((carouselCard, i) => {
      return <Fragment key={`card-${i}`}>{carouselCard}</Fragment>;
    });
  };

  const renderZone = (categoryCards) => {
    const { majorHeader, majorDetails, minorHeader, minorDetails } = categoryCards;

    if (!majorHeader && !majorDetails && !minorHeader && !minorDetails) return null;

    const carouselContentCards = [
      (majorHeader
        && majorDetails
        && (
          <GeneralCardMobile
            type={getCardType(majorHeader.title)}
            header={majorHeader}
            details={majorDetails}
            componentPosition={componentPosition}
            category={majorHeader?.description}
          />
        )
      ),
      (minorHeader
        && minorDetails
        && (
          <GeneralCardMobile
            type={getCardType(minorHeader.title)}
            header={minorHeader}
            details={minorDetails}
            componentPosition={componentPosition}
            category={minorHeader?.description}
          />
        )
      )
    ];

    return (
      <ImpressionProvider
        data={categoryCardsContainerImpression}
      >
        <Col className="category-cards" data-component="CategoryCardsMobile">
          <div
            className="category-cards__zone-wrapper category-cards__zone-card"
            id={`${data.id}-${data.component}-${componentPosition}`}
            data-component-position={componentPosition}
          >
            <Carousel
              multiItem={false}
              showDots
              dotBelow
              showArrows={false}
            >
              {getCarouselCards(carouselContentCards)}
            </Carousel>
          </div>
        </Col>
      </ImpressionProvider>
    );
  };

  if (loading && !data) {
    return <div data-component="CategoryCardsMobilePlaceholder">Loading...</div>;
  }

  if (!data || (!data?.searchModel?.orangeGraph && !data?.getContent) || (!data && error)) {
    return null;
  }

  const categoryCards = new Model(data?.searchModel?.orangeGraph, data?.getContent);

  return categoryCards.isFullCard('mobile')
    ? renderFull(categoryCards)
    : renderZone(categoryCards);
};

CategoryCardsMobile.displayName = 'CategoryCardsMobile';

CategoryCardsMobile.dataModel = dataModel;

CategoryCardsMobile.propTypes = {
  keyword: string,
  navParam: string,
  data: shape({}),
  loading: bool,
  error: shape({}),
  ssr: bool,
  storeId: string,
  componentPosition: number
};

export { CategoryCardsMobile };
